<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1>{{'コンテンツ購入日次情報：検索条件' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="search()">
          <mat-icon>search</mat-icon>
          <span>{{'検索' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content [formGroup]="editForm">
    <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
      <mat-form-field floatLabel="always">
        <mat-label>{{'施設' | translate}}</mat-label>
        <mat-select placeholder="{{'施設' | translate}}" formControlName="facility_id">
          <mat-option [value]=""></mat-option>
          <mat-option *ngFor="let facility of facilities" [value]="facility.id">
            {{ facility.facility_names | multiName:projectLanguages:projectBaseLang }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'建物・カテゴリID' | translate}}</mat-label>
        <input matInput placeholder="{{'建物・カテゴリID' | translate}}" formControlName="hall_id">
        <button mat-button matSuffix aria-label="Search" (click)="openSelectHallsDialog()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'購入日：開始日 - 終了日' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="pickerEvent">
          <input matStartDate formControlName="start_date" placeholder="{{'開始日' | translate}}" readonly>
          <input matEndDate formControlName="end_date" placeholder="{{'終了日' | translate}}" readonly>
        </mat-date-range-input>
        <button mat-button matSuffix aria-label="Clear" (click)="clearDate()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="pickerEvent"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerEvent></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>
</div>
